export const API_URL =
  (process.env.REACT_APP_API_URL as string) || 'http://localhost:3001/api';

// Monday.com integration
export const MONDAY_SUBDOMAIN = 'elink-design';

// Map project prefixes to their Monday.com board IDs
export const MONDAY_BOARD_MAP: Record<string, string> = {
  'MD': '18263540758',      // Metals Depot (App + New platform)
  'MDS': '1381336316',      // Metals Depot (Main Site)
  'NKN': '18099493751',     // Nikon Live
  'PTL': '18298340984',     // Portoll
  'CN': '18107520178',      // Connected Nations
  'JRH': '18210220465',     // J.R Hoe
  'ML': '18287756936',      // Memory Lane - General
  'WP': '18210489961',      // WordPress Sites
};

// Regex to extract project prefix and Monday.com task ID from issue title
// Matches patterns like "MD - 18263543075" or "NKN - 10615572814"
// Captures: group 1 = prefix (e.g., "MD"), group 2 = item ID (e.g., "18263543075")
export const MONDAY_TASK_REGEX = /^([A-Z]+)\s*-\s*(\d{8,})\b/;

export interface MondayTaskInfo {
  prefix: string;
  itemId: string;
  boardId: string | null;
}

export const extractMondayTaskInfo = (title: string): MondayTaskInfo | null => {
  const match = title.match(MONDAY_TASK_REGEX);
  if (!match) return null;

  const prefix = match[1];
  const itemId = match[2];
  const boardId = MONDAY_BOARD_MAP[prefix] || null;

  return { prefix, itemId, boardId };
};

export const getMondayItemUrl = (taskInfo: MondayTaskInfo): string | null => {
  if (!taskInfo.boardId) {
    // Unknown prefix - can't generate a valid URL
    return null;
  }
  return `https://${MONDAY_SUBDOMAIN}.monday.com/boards/${taskInfo.boardId}/pulses/${taskInfo.itemId}`;
};

export const DEFAULT_ROW_HEIGHT = 96;
export const HEADER_ROW_HEIGHT = 48;
export const NOTES_EXTRA_SPACE = 32;

export const POSITION_OPTIONS = [
  'Junior Developer',
  'Developer',
  'Senior Developer',
  'Staff Engineer',
  'Lead Software Engineer'
] as const;

export type Position = (typeof POSITION_OPTIONS)[number];

